import React from 'react';
import { IconProps } from './IconProps';

export const ArrowTopRight2 = (props: IconProps & React.SVGProps<SVGSVGElement>) => {
  const { fill, className, style, ...rest } = props;
  const stroke = fill ?? 'currentColor';
  return (
    <svg
      className={className}
      style={style}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M4.66699 11.3307L11.3337 4.66406"
        stroke={stroke}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66699 4.66406H11.3337V11.3307"
        stroke={stroke}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
